module.exports = __webpack_public_path__ + "static/img/GroupLevel.b9bbb5f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/GroupLevel.svg
// module id = Vsgi
// module chunks = 1